// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button_button__iOuGl {
  max-width: 290px;
  width: 100%;
  height: 38px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 15px;
  background: var(--tg-theme-button-color);
  color: var(--tg-theme-button-text-color);
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
  border-radius: 16px;
  transition: all 0.2s ease;
}
.button_button__iOuGl:active {
  transform: scale(1.1);
  opacity: 0.8;
}
.button_button__iOuGl.button_active__huhtE {
  opacity: 0.5;
}
.button_button__iOuGl.button_disabled__jzXkk {
  opacity: 0.4;
  pointer-events: none;
  cursor: default;
}
.button_button__iOuGl.button_small__fvAU9 {
  height: 32px;
  font-size: 13px;
  padding: 8px 12px;
}
.button_button__iOuGl.button_medium__QqoTi {
  height: 38px;
  font-size: 15px;
  padding: 10px 15px;
}
.button_button__iOuGl.button_large__vMuTO {
  height: 48px;
  font-size: 17px;
  padding: 12px 20px;
}
.button_button__iOuGl.button_primary__-NYk- {
  background: var(--tg-theme-button-color);
  color: var(--tg-theme-button-text-color);
}
.button_button__iOuGl.button_success__DGsrS {
  background: #4caf50;
  color: #fff;
}
.button_button__iOuGl.button_danger__XrCHG {
  background: #f44336;
  color: #fff;
}
.button_button__iOuGl.button_gray__HFFWr {
  background: #9e9e9e;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/shared/button/button.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,wCAAA;EACA,wCAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;AACF;AACE;EACE,qBAAA;EACA,YAAA;AACJ;AAEE;EACE,YAAA;AAAJ;AAGE;EACE,YAAA;EACA,oBAAA;EACA,eAAA;AADJ;AAIE;EACE,YAAA;EACA,eAAA;EACA,iBAAA;AAFJ;AAKE;EACE,YAAA;EACA,eAAA;EACA,kBAAA;AAHJ;AAME;EACE,YAAA;EACA,eAAA;EACA,kBAAA;AAJJ;AAOE;EACE,wCAAA;EACA,wCAAA;AALJ;AAQE;EACE,mBAAA;EACA,WAAA;AANJ;AASE;EACE,mBAAA;EACA,WAAA;AAPJ;AAUE;EACE,mBAAA;EACA,WAAA;AARJ","sourcesContent":[".button {\n  max-width: 290px;\n  width: 100%;\n  height: 38px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 15px;\n  background: var(--tg-theme-button-color);\n  color: var(--tg-theme-button-text-color);\n  font-weight: 500;\n  font-size: 15px;\n  cursor: pointer;\n  border-radius: 16px;\n  transition: all 0.2s ease;\n\n  &:active {\n    transform: scale(1.1);\n    opacity: 0.8;\n  }\n\n  &.active {\n    opacity: 0.5;\n  }\n\n  &.disabled {\n    opacity: 0.4;\n    pointer-events: none;\n    cursor: default;\n  }\n\n  &.small {\n    height: 32px;\n    font-size: 13px;\n    padding: 8px 12px;\n  }\n\n  &.medium {\n    height: 38px;\n    font-size: 15px;\n    padding: 10px 15px;\n  }\n\n  &.large {\n    height: 48px;\n    font-size: 17px;\n    padding: 12px 20px;\n  }\n  // Цветовые стили:\n  &.primary {\n    background: var(--tg-theme-button-color);\n    color: var(--tg-theme-button-text-color);\n  }\n\n  &.success {\n    background: #4caf50;\n    color: #fff;\n  }\n\n  &.danger {\n    background: #f44336;\n    color: #fff;\n  }\n\n  &.gray {\n    background: #9e9e9e;\n    color: #fff;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `button_button__iOuGl`,
	"active": `button_active__huhtE`,
	"disabled": `button_disabled__jzXkk`,
	"small": `button_small__fvAU9`,
	"medium": `button_medium__QqoTi`,
	"large": `button_large__vMuTO`,
	"primary": `button_primary__-NYk-`,
	"success": `button_success__DGsrS`,
	"danger": `button_danger__XrCHG`,
	"gray": `button_gray__HFFWr`
};
export default ___CSS_LOADER_EXPORT___;
